export const policies = {
  cots_and_extra_beds: {
    name: "Bambini e letti",
    icon: "bed",
  },
  minimum_checkin_age: {
    name: "Età minima checkin",
    icon: "occupants",
  },
  maximum_checkin_age: {
    name: "Età massima checkin",
    icon: "occupants",
  },
  minimum_guest_age: {
    name: "Età minima ospiti",
    icon: "user",
  },
  pets: {
    name: "Animali",
    icon: "pets",
  },
  damage: {
    name: "Deposito cauzionale",
    icon: "exclamation",
  }
}

export function get_policies(key) {
  if (policies[key] !== undefined) return policies[key]

  return {
    name: key,
    icon: "symbol_lb",
  }
}